import AutocompleteField from './autocomplete-field.vue';

export default AutocompleteField;
